import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { requestsData } from '../configs/apiOptions';
import { LayoutContext } from '../context';

export const HomeApiProvider = ({ children }) => {

    const [dataList, setDataList] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchDataSequentially = async () => {
            setIsLoading(true);
            try {
                for (const { method, url, payload } of requestsData) {
                    const response = await axios.request({ method, url, data: payload });
                    setDataList(prevData => ({
                        ...prevData,
                        [payload.moduleName]: response.data
                    }));
                }
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchDataSequentially();
    }, []);

    return (
        <LayoutContext.Provider value={{ dataList, error, isLoading }}>
            {children}
        </LayoutContext.Provider>
    )
}
